import './Not_Found.css';
import Temporary_Not_Found_Hero_Image from '../../Assets/Images/Temporary_Not_Found_Hero_Image.png';

const Not_Found = () => <div className='Not_Found_Page'><img src={Temporary_Not_Found_Hero_Image}></img></div>;

export default Not_Found;